import React from "react";
import { useParams } from "react-router-dom";

import { Spinner, Stack, useTheme } from "@bps/fluent-ui";
import {
  FieldConfigurationVersion,
  FieldDevice
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import {
  useFieldDeviceConfiguration,
  useFieldDeviceReportedConfig
} from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SoftwarePackageCommands } from "./SoftwarePackageCommands";

interface SoftwarePackagePageProps {
  device?: FieldDevice;
}

export const SoftwarePackagePage: React.FC<SoftwarePackagePageProps> = ({
  device
}) => {
  const theme = useTheme();

  const { softwarePackageCode } = useParams();
  const {
    data: deviceReportedConfig,
    isLoading: reportedLoading
  } = useFieldDeviceReportedConfig(device?.id!);

  const {
    data: deviceDesiredConfig,
    isLoading: desiredLoading
  } = useFieldDeviceConfiguration(device?.id!, FieldConfigurationVersion.V3_0);

  const reportedConfig = deviceReportedConfig?.find(
    config => config.softwarePackageCode === softwarePackageCode
  );

  const desiredConfig =
    // Find software package from current or future components list
    deviceDesiredConfig?.currentComponents?.find(
      component => component.code === softwarePackageCode
    ) ??
    deviceDesiredConfig?.futureComponents?.find(
      component => component.code === softwarePackageCode
    ) ??
    undefined;

  return (
    <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
      {!desiredLoading && !reportedLoading ? (
        <SoftwarePackageCommands
          reportedConfig={reportedConfig}
          desiredConfig={desiredConfig}
          device={device}
        />
      ) : (
        <Spinner />
      )}
    </Stack>
  );
};
